import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const direction = {
  up: "180deg",
  down: "0",
  left: "90deg",
  right: "270deg"
};

const setFillColor = props => {
  if (props.isWrapped) {
    return "currentColor";
  }

  return props.designFillColor || colors[props.fillColor];
};

const Wrapper = styled.svg.attrs({
  focusable: false
})`
  padding: ${props => props.desktopPadding};
  transform: rotate(${props => direction[props.direction]});

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }
`;

const Outline = styled.g`
  fill: ${props => setFillColor(props)};
`;

const Rect = styled.rect`
  fill: ${props => setFillColor(props)};
`;

const IconWrapper = styled.span`
  box-sizing: border-box;
  display: inline-block;
  line-height: 0;
  padding: ${props => props.desktopPadding};

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }

  * {
    box-sizing: border-box;
  }
`;

export { Outline, Wrapper, IconWrapper, Rect };
